"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Docs = void 0;
const core_1 = require("@beautiful-eyes/core");
const docs_template_be_1 = __importDefault(require("./docs.template.be"));
require("./reactive-class.component");
require("./components.component");
require("./children.component");
require("./templates.component");
require("./examples.component");
let Docs = (() => {
    let _classDecorators = [(0, core_1.Component)({
            selector: 'Docs',
            useTemplate: docs_template_be_1.default,
            useStyleSheets: []
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = core_1.ReactiveClass;
    let _activeSection_decorators;
    let _activeSection_initializers = [];
    let _activeSection_extraInitializers = [];
    let _navOpen_decorators;
    let _navOpen_initializers = [];
    let _navOpen_extraInitializers = [];
    var Docs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.activeSection = __runInitializers(this, _activeSection_initializers, 'reactive-class');
            this.navOpen = (__runInitializers(this, _activeSection_extraInitializers), __runInitializers(this, _navOpen_initializers, false));
            this.toc = (__runInitializers(this, _navOpen_extraInitializers), [
                { key: 'reactive-class', label: 'Reactive Class', heading: 'Language' },
                { key: 'components', label: 'Components', heading: '' },
                { key: 'children', label: 'Children', heading: '' },
                { key: 'templates', label: 'Templates', heading: '' },
                { key: 'examples', label: 'Examples', heading: 'Practice' },
            ]);
        }
        selectSection(key) {
            this.activeSection = key;
            this.navOpen = false;
            queueMicrotask(() => {
                const pane = document.querySelector('.contrib-content');
                if (pane)
                    pane.scrollTop = 0;
            });
        }
        toggleNav() {
            this.navOpen = !this.navOpen;
        }
        closeNav() {
            this.navOpen = false;
        }
    };
    __setFunctionName(_classThis, "Docs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _activeSection_decorators = [(0, core_1.State)()];
        _navOpen_decorators = [(0, core_1.State)()];
        __esDecorate(null, null, _activeSection_decorators, { kind: "field", name: "activeSection", static: false, private: false, access: { has: obj => "activeSection" in obj, get: obj => obj.activeSection, set: (obj, value) => { obj.activeSection = value; } }, metadata: _metadata }, _activeSection_initializers, _activeSection_extraInitializers);
        __esDecorate(null, null, _navOpen_decorators, { kind: "field", name: "navOpen", static: false, private: false, access: { has: obj => "navOpen" in obj, get: obj => obj.navOpen, set: (obj, value) => { obj.navOpen = value; } }, metadata: _metadata }, _navOpen_initializers, _navOpen_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        Docs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return Docs = _classThis;
})();
exports.Docs = Docs;
